// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"528":"96388bca","797":"32fdbdb0"}[chunkId] + ".chunk.js";
};